import slug from "slug";

export default function slugify(text, replacement = '-') {
  return slug(text, { lower: true, replacement })
}
